import { Path } from 'enums';
import CustomerAccountModule from 'modules/customer-account/customer-account.module';
import CustomerModule from 'modules/customer/customer.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';
// import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

const CustomerPage = () => {
  return (
    <Switch>
      <Route exact path={Path.MemberList} component={CustomerModule} />
      <Route exact path={Path.MemberAccount} component={CustomerAccountModule} />
    </Switch>
  );
};

export default CustomerPage;
